module.exports = __webpack_public_path__ + "static/img/knowlogo.279c201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knowlogo.png
// module id = VMfY
// module chunks = 1